const accentColors = [
  { bar: "bg-blue-primary-500", iconBg: "bg-blue-primary-500/10", iconText: "text-blue-primary-500" },
  { bar: "bg-semantic-negative-500", iconBg: "bg-semantic-negative-500/10", iconText: "text-semantic-negative-500" },
  { bar: "bg-semantic-positive-500", iconBg: "bg-semantic-positive-500/10", iconText: "text-semantic-positive-500" },
  { bar: "bg-semantic-notice-500", iconBg: "bg-semantic-notice-500/10", iconText: "text-semantic-notice-500" },
  { bar: "bg-[#8B5CF6]", iconBg: "bg-[#8B5CF6]/10", iconText: "text-[#8B5CF6]" },
];

export default function ComparisonDifferences({ title, subtitle, cards }) {
  return (
    <section className="py-[100px] px-6 lg:px-10 bg-cream">
      <div className="max-w-[1100px] mx-auto">
        <h2 className="font-inter text-[24px] sm:text-[32px] lg:text-[38px] font-black tracking-[-1.5px] leading-[1.15] mb-4 text-center fade-in">
          {title}
        </h2>
        <p className="font-inter text-base text-gray-cool-500 leading-[1.7] max-w-[700px] mx-auto mb-12 text-center fade-in">
          {subtitle}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card, i) => {
            const accent = accentColors[i % accentColors.length];
            return (
              <div
                key={i}
                className="bg-base-white rounded-[20px] p-8 border border-gray-cool-200 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(0,0,0,0.08)] hover:border-transparent relative overflow-hidden fade-in"
              >
                {/* Left accent bar */}
                <div
                  className={`absolute top-0 left-0 w-1 h-full rounded-l-[20px] ${accent.bar}`}
                />
                {/* Icon */}
                <div
                  className={`w-11 h-11 rounded-xl flex items-center justify-center text-lg mb-4 ${accent.iconBg} ${accent.iconText}`}
                >
                  {card.icon}
                </div>
                <h4 className="font-inter text-[17px] font-bold tracking-[-0.3px] mb-2">
                  {card.title}
                </h4>
                <p className="font-inter text-sm text-gray-cool-500 leading-[1.65]">
                  {card.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
